const DEFAULT_DESC = "Describe your business once, explore UK IP protection options, find matching grants and funding, and prepare applications in one secure guided workspace.";

const META = {
  "/": ["IP protection and funding, made simple", DEFAULT_DESC],
  "/how-it-works": ["How it works", "See the guided journey: build your business profile, assess IP protection options, match funding and prepare applications step by step."],
  "/ip-protection": ["IP protection options in the UK", "Understand UK patents, trade marks, registered designs, copyright and confidential know-how, and which routes may suit your innovation."],
  "/grants-funding": ["UK grants and funding opportunities", "Browse UK grants, vouchers, loans and competitions with official source links, deadlines and eligibility notes."],
  "/pricing": ["Pricing", "Simple plans for preparing IP and funding applications, from free exploration to supported expert review."],
  "/expert-support": ["Expert support", "Request a review from vetted IP and funding advisers before you file or submit."],
  "/faqs": ["FAQs", "Answers on UK patents, copyright, trade marks, grants and how the platform prepares and tracks your applications."],
  "/contact": ["Contact us", "Get in touch with questions, platform support or an expert review request."],
  "/thank-you": ["Thank you", "Your message has been received."],
  "/westmont": ["Westmont Enterprise Hub", "How Protect & Fund connects to the Westmont Enterprise Hub at the University of West London: membership categories, approved benefits and how to apply."],
  "/what-you-need": ["What you'll need to apply", "A tick-box checklist of the information and documents you need for UK grant, patent, trade mark, design, copyright and know-how applications. Download it as a PDF."],
  "/privacy": ["Privacy policy", "How we collect, use, protect and retain your personal data under UK GDPR."],
  "/terms": ["Terms of use", "The terms that apply when you use the website and platform."],
  "/cookies": ["Cookie policy", "Which cookies we use, why, and how to change your choice."],
  "/login": ["Sign in", "Sign in to your secure workspace."],
};

const PREFIX = [["/grants-funding/", "Funding opportunity", "Eligibility notes, deadlines and the official source for this UK funding opportunity."]];

export const NOT_FOUND = ["Page not found", "The page you were looking for could not be found."];

const OVERRIDES = {};
export const setPageMeta = (path, meta) => { OVERRIDES[path] = meta; };

export const metaFor = (path) => {
  if (OVERRIDES[path]) return OVERRIDES[path];
  if (META[path]) return { title: META[path][0], desc: META[path][1], index: path !== "/thank-you" };
  const p = PREFIX.find(([pre]) => path.startsWith(pre));
  if (p) return { title: p[1], desc: p[2], index: true };
  if (path.startsWith("/app") || path === "/mfa") return { title: "Workspace", desc: DEFAULT_DESC, index: false };
  return { title: NOT_FOUND[0], desc: NOT_FOUND[1], index: false };
};

const setTag = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const applyMeta = ({ title, desc, index }, siteName, path) => {
  const full = path === "/" ? `${siteName} | ${title}` : `${title} | ${siteName}`;
  document.title = full;
  const url = window.location.origin + path;
  setTag("name", "description", desc);
  setTag("name", "robots", index ? "index, follow" : "noindex, nofollow");
  setTag("property", "og:title", full);
  setTag("property", "og:description", desc);
  setTag("property", "og:url", url);
  setTag("property", "og:image", `${window.location.origin}/og-image.png`);
  setTag("name", "twitter:title", full);
  setTag("name", "twitter:description", desc);
  setTag("name", "twitter:image", `${window.location.origin}/og-image.png`);
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = url;
  return full;
};
